import { Role, RoleType } from "../models/user";
export interface RouteData {
  n: string;
  p: string;
  r?: Role[];
}
export interface RouteName {
  NoAccess: RouteData;
  KitchenSink: RouteData;
  KitchenSink2: RouteData;
  KitchenSink3: RouteData;
  TA: TARouteName;
}

export interface TARouteName {
  Home: RouteData;
  LoginPage: RouteData;
  LogoutPage: RouteData;
  Main: RouteData;
  TrustData: RouteData;
  TrustDataPractices: RouteData;
  TrustDataAccountingSoftware: RouteData;
  TrustDataInvestigationType: RouteData;
  TrustDataInvestigators: RouteData;
  TrustDataBanks: RouteData;
  TrustDataTrustTeam: RouteData;
  TrustDataExternalExaminer: RouteData;
  TrustDataExternalExaminerApproval: RouteData;
  TrustDataExternalExaminerSignUpApproval: RouteData;
  TrustDataPageSettings: RouteData;
  Investigations: RouteData;
  Routines: RouteData;
  FollowUp: RouteData;
  TimesheetApproval: RouteData;
  Investigator: RouteData;
  InvestigatorDashboard: RouteData;
  InvestigatorCalendar: RouteData;
  InvestigatorInvestigations: RouteData;
  InvestigatorTimesheets: RouteData;
  Practice: RouteData;
  PracticeDashboard: RouteData;
  PracticeInvestigationDetails: RouteData;
  PracticeBank: RouteData;
  PracticeAccountingDetails: RouteData;
  PracticeNotes: RouteData;
  PracticePeople: RouteData;
  PracticeCorrespondence: RouteData;
  PracticeLinkedPractice: RouteData;
  PracticeTrustCompliance: RouteData;
  ExternalExaminer: RouteData;
  ExternalExaminerDashboard: RouteData;
}

export const RouteN: RouteName = {
  NoAccess: { n: 'no-access', p: '/no-access' },
  KitchenSink: { n: 'kitchen-sink', p: '/kitchen-sink' },
  KitchenSink2: { n: 'kitchen-sink2', p: '/kitchen-sink2' },
  KitchenSink3: { n: 'kitchen-sink3', p: '/kitchen-sink3' },
  TA: {
    Home: { n: 'Home', p: '/home' },
    TrustData: {
      n: 'trustdata',
      p: '/trust-data',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    TrustDataPractices: {
      n: 'trustdata-practices',
      p: '/trust-data/practices',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    TrustDataAccountingSoftware: {
      n: 'trustdata-accounting-software',
      p: '/trust-data/accounting-software',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin
      ]
    },
    TrustDataInvestigationType: {
      n: 'trustdata-investigation-type',
      p: '/trust-data/investigation-type',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin
      ]
    },
    TrustDataInvestigators: {
      n: 'trustdata-investigators',
      p: '/trust-data/investigators',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin
      ]
    },
    TrustDataBanks: {
      n: 'trustdata-banks',
      p: '/trust-data/banks',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin
      ]
    },
    TrustDataTrustTeam: {
      n: 'trustdata-trust-team',
      p: '/trust-data/trust-team',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustSectionLeader,
        RoleType.TrustManager
      ]
    },
    TrustDataExternalExaminer: {
      n: 'trustdata-external-examiner',
      p: '/trust-data/external-examiner',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustSectionLeader,
        RoleType.TrustManager
      ]
    },
    TrustDataExternalExaminerApproval: {
      n: 'trustdata-external-examiner-approval',
      p: '/trust-data/external-examiner-approval',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustSectionLeader,
        RoleType.TrustManager
      ]
    },
    TrustDataExternalExaminerSignUpApproval: {
      n: 'trustdata-external-examiner-sign-up-approval',
      p: '/trust-data/external-examiner-sign-up-approval',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustSectionLeader,
        RoleType.TrustManager
      ]
    },
    TrustDataPageSettings: {
      n: 'trustdata-page-settings',
      p: '/trust-data/page-settings',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustSectionLeader,
        RoleType.TrustManager
      ]
    },
    LoginPage: { n: 'login', p: '/check-auth' },
    LogoutPage: { n: 'logout', p: '/signout' },
    Main: {
      n: 'ta-home',
      p: '/',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    Investigations: {
      n: 'investigations-main',
      p: '/investigations',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    Routines: {
      n: 'routines',
      p: '/routines',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    FollowUp: {
      n: 'follow-up',
      p: '/follow-up',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    TimesheetApproval: {
      n: 'timesheet-approval',
      p: '/timesheet-approval',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    Investigator: {
      n: 'investigator-main',
      p: '/investigator',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    InvestigatorDashboard: {
      n: 'investigator-dashboard',
      p: '/investigator/dashboard',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    InvestigatorCalendar: {
      n: 'investigator-calendar',
      p: '/investigator/calendar',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    InvestigatorInvestigations: {
      n: 'investigator-investigation',
      p: '/investigator/investigations',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    InvestigatorTimesheets: {
      n: 'investigator-timesheets',
      p: '/investigator/timesheets',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    Practice: {
      n: 'practice-main',
      p: '/practice',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeDashboard: {
      n: 'practice-dashboard',
      p: '/practice/dashboard',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeInvestigationDetails: {
      n: 'practice-investigation-details',
      p: '/practice/investigation-details',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeBank: {
      n: 'practice-bank',
      p: '/practice/bank',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeAccountingDetails: {
      n: 'practice-accounting-details',
      p: '/practice/accounting-details',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeNotes: {
      n: 'practice-notes',
      p: '/practice/notes',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticePeople: {
      n: 'practice-people',
      p: '/practice/people',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeCorrespondence: {
      n: 'practice-correspondence',
      p: '/practice/correspondence',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeLinkedPractice: {
      n: 'practice-linked-practice',
      p: '/practice/linked-practice',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    PracticeTrustCompliance: {
      n: 'practice-trust-compliance',
      p: '/practice/trust-compliance',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    ExternalExaminer: {
      n: 'external-examiner-main',
      p: '/external-examiner',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
    ExternalExaminerDashboard: {
      n: 'external-examiner-dashboard',
      p: '/external-examiner/dashboard',
      r: [
        RoleType.TrustAdmin,
        RoleType.TrustSuperAdmin,
        RoleType.TrustManager,
        RoleType.TrustSectionLeader
      ]
    },
  }
};
